import React from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.css";

const Sidebar: React.FC = () => {
  const adminDetail = localStorage.getItem("adminDetail");
  const roleName = adminDetail
    ? JSON.parse(adminDetail)?.roleIds?.roleName
    : null;

  const isAdmin = roleName === "admin";

  const sections = [
    {
      heading: "Manage",
      items: [
        {
          label: "Category",
          path: "/app/manage-category",
          roles: ["admin", "super-admin"],
        },
        {
          label: "Courses",
          path: "/app/manage-courses",
          roles: ["admin", "super-admin"],
        },
        {
          label: "Codes",
          path: "/app/manage-codes",
          roles: ["super-admin", "admin"],
        },
        {
          label: "Libraries",
          path: "/app/manage-libraries",
          roles: ["super-admin"],
        },
        { label: "Admins", path: "/app/manage-admins", roles: ["super-admin"] },
        {
          label: "FAQs",
          path: "/app/manage-faqs",
          roles: ["admin", "super-admin"],
        },
        {
          label: "Landing Page",
          path: "/app/manage-landingpage",
          roles: ["admin", "super-admin"],
        },
      ],
    },
    {
      heading: "Review",
      items: [
        {
          label: "Voucher Requests",
          path: "/app/review-voucher-requests",
          roles: ["super-admin"],
        },
      ],
    },
    {
      heading: "Reports",
      items: [
        {
          label: "View Reports",
          path: "/app/reports",
          roles: ["admin", "super-admin"],
        },
      ],
    },
  ];

  return (
    <div className="sidebar">
      {sections.map((section) => {
        const visibleItems = section.items.filter((item) =>
          item.roles.includes(roleName)
        );

        if (visibleItems.length === 0) return null;

        return (
          <div key={section.heading} className="sidebar-section">
            <div className="sidebar-heading">{section.heading}</div>
            {visibleItems.map((tab) => (
              <NavLink
                key={tab.path}
                to={tab.path}
                className={({ isActive }) =>
                  isActive ? "sidebar-link active" : "sidebar-link"
                }
              >
                {tab.label}
              </NavLink>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default Sidebar;
